import React, { useState } from 'react';

export default function ConsultationDetail({ visible, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
  });
  const [errors, setErrors] = useState({
    name: '',
    mobile: '',
    email: '',
  });
  const [submitted, setSubmitted] = useState(false);

  if (!visible) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Basic form validation
    let formErrors = {};

    if (!formData.name) formErrors.name = 'Name is required';
    if (!formData.mobile) formErrors.mobile = 'Mobile is required';
    if (!/^\d{10}$/.test(formData.mobile)) formErrors.mobile = 'Please enter a valid 10-digit mobile number';
    if (!formData.email) formErrors.email = 'Email is required';
    if (!/\S+@\S+\.\S+/.test(formData.email)) formErrors.email = 'Please enter a valid email address';
    
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    const payload = {
      name: formData.name,
      mobile: formData.mobile,
      email: formData.email,
    };

    try {
      const response = await fetch('https://app.yaper.co/api/v2/retail/consult', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: '', mobile: '', email: '' });
      } else {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        alert('Something went wrong. Please try again later.');
      }
    } catch (error) {
      console.error('Error sending request:', error);
      alert('An error occurred while sending the request.');
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button onClick={onClose} style={styles.closeIcon} aria-label="Close popup">&times;</button>

        {!submitted ? (
          <form onSubmit={handleFormSubmit}>
            <div style={styles.inputGroup}>
              <label>Name</label>
              <input
                name="name"
                type="text"
                placeholder="John Doe"
                value={formData.name}
                onChange={handleChange}
                style={styles.input}
                required
              />
              {errors.name && <p style={styles.errorText}>{errors.name}</p>}
            </div>
            <div style={styles.inputGroup}>
              <label>Contact Number</label>
              <input
                name="mobile"
                type="text"
                placeholder="9511225450"
                value={formData.mobile}
                onChange={handleChange}
                style={styles.input}
                required
              />
              {errors.mobile && <p style={styles.errorText}>{errors.mobile}</p>}
            </div>
            <div style={styles.inputGroup}>
              <label>Email</label>
              <input
                name="email"
                type="email"
                placeholder="example@mail.com"
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
                required
              />
              {errors.email && <p style={styles.errorText}>{errors.email}</p>}
            </div>
            <button type="submit" style={styles.submitBtn}>SUBMIT</button>
          </form>
        ) : (
          <>
            <h2 style={styles.title}>Thank You!</h2>
            <p style={styles.desc}>Your consultation request has been sent successfully. Our team will reach out to you shortly.</p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999,
  },
  modal: {
    position: 'relative',
    background: '#fff',
    padding: '2rem',
    borderRadius: '12px',
    width: '100%',
    maxWidth: '450px',
    textAlign: 'left',
    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
  },
  inputGroup: {
    marginBottom: '1.2rem',
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '0.75rem',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    marginTop: '5px',
  },
  errorText: {
    color: 'red',
    fontSize: '12px',
    marginTop: '5px',
  },
  submitBtn: {
    width: '100%',
    background: '#1E3FA6',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '0.75rem',
    fontWeight: 600,
    fontSize: '1rem',
    cursor: 'pointer',
    marginTop: '1rem',
  },
  closeIcon: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    background: 'transparent',
    border: 'none',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#333',
    cursor: 'pointer',
    lineHeight: 1,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '0.5rem',
    textAlign: 'center',
  },
  desc: {
    fontSize: '1rem',
    textAlign: 'center',
  },
};
